import * as React from 'react';
import { drawRoofButtonToolTipText } from '__editor/googleMapsRoofsSelector/components/drawingManager/utils/drawRoofButtonToolTip';
import { AlertInstance, showCustomNotifyAlert } from '__common/modules/alerts';

let activeGuidanceAlert: AlertInstance | null = null;
let activeMoveGuidanceAlert: AlertInstance | null = null;

export const ADD_PANEL_TOOLTIP = 'Add modules';
export const MARK_ROOF_TOOLTIP = 'Draw roof shape';
export const ADD_PANEL_INITIAL_TOOLTIP = 'Click here to add modules';
export const MARK_ROOF_INITIAL_TOOLTIP = 'Click here to Start drawing the roof';

const addPanelGuidance = `
  <p><b>Tip&#8594;</b> Click and drag on the active roof to define the module area.</p>
  <p><b>Tip&#8594;</b> Release the mouse to add modules. The cursor tooltip shows the row x column count while dragging.</p>
`;

const moveArrayGuidance = `
  <p><b>Tip&#8594;</b> Hover over the selected array to start moving it.</p>
  <p><b>Tip&#8594;</b> Click on the new position to place it. Press Escape to cancel.</p>
`;

type HoverTooltipProps = {
  id: string;
  label?: string;
  open?: boolean;
  children: React.ReactNode;
};

export const V3ToolHoverTooltip: React.SFC<HoverTooltipProps> = ({ id, label, open, children }) => (
  <span className={`v3-tool-hover-tooltip-wrap ${open ? 'is-open' : ''}`}>
    {children}
    {label && (
      <span id={`v3-${id}-hover-tooltip`} className="v3-tool-hover-tooltip" role="tooltip">
        {label}
      </span>
    )}
  </span>
);

export function dismissV3ToolGuidance() {
  if (activeGuidanceAlert) {
    activeGuidanceAlert.dismiss();
    activeGuidanceAlert = null;
  }
}

export function showV3ToolGuidance(tool: string | null, productId: number | null) {
  dismissV3ToolGuidance();

  if (tool === 'addpanel') {
    activeGuidanceAlert = showCustomNotifyAlert(addPanelGuidance, 10);
  }

  if (tool === 'markroof') {
    activeGuidanceAlert = showCustomNotifyAlert(drawRoofButtonToolTipText(productId || 0), 10);
  }
}

export function showMoveArrayGuidance() {
  dismissMoveArrayGuidance();
  activeMoveGuidanceAlert = showCustomNotifyAlert(moveArrayGuidance, 10);
}

export function dismissMoveArrayGuidance() {
  if (activeMoveGuidanceAlert) {
    activeMoveGuidanceAlert.dismiss();
    activeMoveGuidanceAlert = null;
  }
}
